import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVuetifyComponent } from './simple-icons-vuetify.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVuetifyComponent ],
    exports:      [ SimpleIconsVuetifyComponent ],
    bootstrap:    []
})
export class SimpleIconsVuetifyModule {}
